webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(119);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(99);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	    el: '#app',
	    template: '<App />',
	    components: { App: _App2.default }
	});
	
	if ('serviceWorker' in navigator) {
	    navigator.serviceWorker.register('service-worker.js').then(function (reg) {
	        reg.onupdatefound = function () {
	            var installingWorker = reg.installing;
	
	            installingWorker.onstatechange = function () {
	                switch (installingWorker.state) {
	                    case 'installed':
	                        if (navigator.serviceWorker.controller) {
	                            console.log('New or updated content is available.');
	                        } else {
	                            console.log('Content is now available offline!');
	                        }
	                        break;
	
	                    case 'redundant':
	                        console.error('The installing service worker became redundant.');
	                        break;
	                }
	            };
	        };
	    }).catch(function (e) {
	        console.error('Error during service worker registration:', e);
	    });
	}

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(50);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _sampler = __webpack_require__(16);
	
	var _sampler2 = _interopRequireDefault(_sampler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_sampler2.default.init();
	
	function purgeArray(arr, val) {
	  for (var i = 0; i < arr.length; i++) {
	    if (arr[i] === val) {
	      arr.splice(i, 1);
	      i--;
	    }
	  }
	
	  return arr;
	}
	
	exports.default = {
	  settings: {
	    delay: 0.15
	  },
	
	  state: {
	    mouseDown: false,
	    soundsPlaying: {},
	    notesPlaying: []
	  },
	
	  startNote: function startNote(midiNumber) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var chorded = options.chorded;
	
	
	    if (this.state.soundsPlaying[midiNumber]) {
	      return;
	    }
	
	    var noteAudioContext = void 0;
	
	    try {
	      noteAudioContext = new AudioContext();
	    } catch (exception) {
	      return;
	    }
	
	    var audioData = _sampler2.default.getCurrentSound();
	    var source = noteAudioContext.createBufferSource();
	
	    source.buffer = audioData;
	
	    var gainNode = noteAudioContext.createGain();
	
	    source.connect(gainNode);
	    gainNode.connect(noteAudioContext.destination);
	
	    source.playbackRate.value = _sampler2.default.getPitchRatio(midiNumber);
	
	    source.start(0);
	
	    this.state.soundsPlaying[midiNumber] = { noteAudioContext: noteAudioContext, gainNode: gainNode };
	
	    this.state.notesPlaying.push(midiNumber);
	
	    document.dispatchEvent(new CustomEvent('noteStart', { detail: { midiNumber: midiNumber, chorded: chorded } }));
	  },
	  stopNote: function stopNote(midiNumber) {
	    var _this = this;
	
	    if (!this.state.soundsPlaying[midiNumber]) {
	      return;
	    }
	
	    var _state$soundsPlaying$ = this.state.soundsPlaying[midiNumber],
	        noteAudioContext = _state$soundsPlaying$.noteAudioContext,
	        gainNode = _state$soundsPlaying$.gainNode;
	
	
	    gainNode.gain.linearRampToValueAtTime(0, noteAudioContext.currentTime + 0.05);
	
	    setTimeout(function () {
	      document.dispatchEvent(new CustomEvent('noteStop', { detail: { midiNumber: midiNumber } }));
	
	      delete _this.state.soundsPlaying[midiNumber];
	
	      purgeArray(_this.state.notesPlaying, midiNumber);
	
	      noteAudioContext.close();
	    }, 50);
	  },
	  playChord: function playChord(chordNotes) {
	    var _this2 = this;
	
	    var steps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return new _promise2.default(function (resolve) {
	      var delay = steps ? 200 : 0;
	
	      chordNotes.forEach(function (midiNumber, i) {
	        var startAt = (i + 1) * delay;
	        var duration = 2000;
	        var chorded = true;
	
	        setTimeout(function () {
	          _this2.startNote(midiNumber, { duration: duration, chorded: chorded });
	        }, startAt);
	
	        setTimeout(function () {
	          _this2.stopNote(midiNumber);
	
	          if (i === chordNotes.length - 1) {
	            resolve();
	          }
	        }, startAt + duration);
	      });
	    });
	  }
	};

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _audioContexts = __webpack_require__(38);
	
	var _audioContexts2 = _interopRequireDefault(_audioContexts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sampler = {
	  currentAudioData: undefined,
	
	  midiToFrequency: function midiToFrequency(midiNumber) {
	    return 440 * Math.pow(2, (midiNumber - 69) / 12);
	  },
	  getPitchRatio: function getPitchRatio(midiNumber) {
	    return this.midiToFrequency(midiNumber) / this.midiToFrequency(60);
	  },
	  getCurrentSound: function getCurrentSound() {
	    return this.currentAudioData;
	  },
	  createSample: function createSample(audioData) {
	    this.currentAudioData = audioData;
	  },
	  loadSound: function loadSound(soundPath) {
	    var _this = this;
	
	    this.source = this.audioCtx.context.createBufferSource();
	
	    var request = new Request(soundPath);
	
	    fetch(request).then(function (response) {
	      response.arrayBuffer().then(function (arrayBuffer) {
	        return _this.loadArrayBuffer(arrayBuffer);
	      });
	    });
	  },
	  loadArrayBuffer: function loadArrayBuffer(arrayBuffer) {
	    var _this2 = this;
	
	    this.audioCtx.context.decodeAudioData(arrayBuffer).then(function (audioData) {
	      return _this2.createSample(audioData);
	    }).then(function () {
	      return _this2.freeAudioContext;
	    });
	  },
	  loadAudioData: function loadAudioData(audioData) {
	    this.createSample(audioData);
	  },
	  makePathFromSoundName: function makePathFromSoundName(soundName) {
	    if (!soundName) {
	      throw new Error('No soundname passed in.');
	    }
	
	    return ['static', 'sounds', soundName].join('/');
	  },
	  freeAudioContext: function freeAudioContext() {
	    _audioContexts2.default.freeAudioContext(this.audioCtx.guid);
	  },
	  init: function init() {
	    this.audioCtx = _audioContexts2.default.getFreeAudioContext();
	
	    var soundPath = this.makePathFromSoundName('piano.mp3');
	
	    this.loadSound(soundPath);
	  }
	};
	
	exports.default = Sampler;

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function generateGUID() {
	  function s4() {
	    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	  }
	
	  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	}
	
	var audioContexts = [];
	
	exports.default = {
	  getFreeAudioContext: function getFreeAudioContext() {
	    if (audioContexts.length > 5) {
	      return;
	    }
	
	    var audioContext = {
	      context: new AudioContext(),
	      guid: generateGUID()
	    };
	
	    audioContexts.push(audioContext);
	
	    return audioContext;
	  },
	  freeAudioContext: function freeAudioContext(guid) {
	    var audioContext = audioContexts.filter(function (ctx) {
	      return ctx.guid === guid;
	    })[0];
	    var newAudioContexts = audioContexts.filter(function (ctx) {
	      return ctx.guid !== guid;
	    });
	
	    audioContext.context.close();
	
	    audioContexts = newAudioContexts;
	  }
	};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _piano = __webpack_require__(9);
	
	var _piano2 = _interopRequireDefault(_piano);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getKeyCodeFromEvent(event) {
	  var returnValue = event.keyCode;
	
	  returnValue = 'which' in event ? event.which : returnValue;
	
	
	  return returnValue;
	}
	
	function getMidiFromKeyCode(keyCode) {
	  var keyCodes = [90, 83, 88, 68, 67, 86, 71, 66, 72, 78, 74, 77, 81, 50, 87, 51, 69, 82, 53, 84, 54, 89, 55, 85, 73, 57, 79, 48, 80];
	
	  var index = 48 + keyCodes.indexOf(keyCode);
	
	  return keyCodes.includes(keyCode) ? index : undefined;
	}
	
	var ComputerKeyboard = {
	  getMidiFromEvent: function getMidiFromEvent(event) {
	    return this.getMidiFromKeyCode(this.getKeyCodeFromEvent(event));
	  },
	
	
	  getKeyCodeFromEvent: getKeyCodeFromEvent,
	  getMidiFromKeyCode: getMidiFromKeyCode,
	
	  onKeyDown: function onKeyDown(event) {
	    if (event.defaultPrevented) {
	      return;
	    }
	
	    var keyCode = getKeyCodeFromEvent(event);
	    var midiNumber = getMidiFromKeyCode(keyCode);
	
	    if (!midiNumber) {
	      return;
	    }
	
	    _piano2.default.startNote(midiNumber);
	
	    event.preventDefault();
	  },
	  onKeyUp: function onKeyUp(event) {
	    if (event.defaultPrevented) {
	      return;
	    }
	
	    var keyCode = getKeyCodeFromEvent(event);
	    var midiNumber = getMidiFromKeyCode(keyCode);
	
	    if (!midiNumber) {
	      return;
	    }
	
	    _piano2.default.stopNote(midiNumber);
	
	    event.preventDefault();
	  },
	  init: function init() {
	    document.addEventListener('keydown', this.onKeyDown);
	    document.addEventListener('keyup', this.onKeyUp);
	  }
	};
	
	exports.default = ComputerKeyboard;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _piano = __webpack_require__(9);
	
	var _piano2 = _interopRequireDefault(_piano);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function init() {
	  if (navigator.requestMIDIAccess) {
	    navigator.requestMIDIAccess({
	      sysex: false }).then(onMIDISuccess, onMIDIFailure);
	  } else {
	    console.error('No MIDI support in your browser.');
	  }
	
	  function onMIDISuccess(midiAccess) {
	    var inputs = midiAccess.inputs.values();
	
	    for (var input = inputs.next(); input && !input.done; input = inputs.next()) {
	      input.value.onmidimessage = onMIDIMessage;
	    }
	  }
	
	  function onMIDIFailure(e) {
	    console.log('No access to MIDI devices or your browser doesn\'t support WebMIDI API. Please use WebMIDIAPIShim ' + e);
	  }
	
	  function onMIDIMessage(event) {
	    switch (event.data[0] & 0xf0) {
	      case 0x90:
	        if (event.data[2] != 0) {
	          _piano2.default.startNote(event.data[1]);
	
	          return;
	        }
	
	      case 0x80:
	        _piano2.default.stopNote(event.data[1]);
	    }
	  }
	}
	
	exports.default = { init: init };

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Plypp = __webpack_require__(100);
	
	var _Plypp2 = _interopRequireDefault(_Plypp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Plypp: _Plypp2.default
	  }
	};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keyboard = __webpack_require__(103);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _soundSelector = __webpack_require__(108);
	
	var _soundSelector2 = _interopRequireDefault(_soundSelector);
	
	var _chordSelector = __webpack_require__(102);
	
	var _chordSelector2 = _interopRequireDefault(_chordSelector);
	
	var _adsContainer = __webpack_require__(101);
	
	var _adsContainer2 = _interopRequireDefault(_adsContainer);
	
	var _socialFooter = __webpack_require__(105);
	
	var _socialFooter2 = _interopRequireDefault(_socialFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Keyboard: _keyboard2.default,
	    SoundSelector: _soundSelector2.default,
	    ChordSelector: _chordSelector2.default,
	    AdsContainer: _adsContainer2.default,
	    SocialFooter: _socialFooter2.default
	  }
	};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _socialInteractions = __webpack_require__(106);
	
	var _socialInteractions2 = _interopRequireDefault(_socialInteractions);
	
	var _socialLinks = __webpack_require__(107);
	
	var _socialLinks2 = _interopRequireDefault(_socialLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SocialInteractions: _socialInteractions2.default,
	    SocialLinks: _socialLinks2.default
	  }
	};

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  mounted: function mounted() {
	    var adsbygoogle = document.createElement('script');
	    var adpusher = document.createElement('script');
	
	    adsbygoogle.src = '//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
	    adpusher.innerHTML = '(adsbygoogle = window.adsbygoogle || []).push({});';
	
	    document.body.appendChild(adsbygoogle);
	    document.body.appendChild(adpusher);
	  }
	};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _piano = __webpack_require__(9);
	
	var _piano2 = _interopRequireDefault(_piano);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var keys = [{ name: '--', value: undefined }, { name: 'C', value: 60 }, { name: 'C#', value: 61 }, { name: 'D', value: 62 }, { name: 'D#', value: 63 }, { name: 'E', value: 64 }, { name: 'F', value: 65 }, { name: 'F#', value: 66 }, { name: 'G', value: 67 }, { name: 'G#', value: 68 }, { name: 'A', value: 69 }, { name: 'A#', value: 70 }, { name: 'B', value: 71 }];
	
	var flavours = [{ name: '--', value: undefined }, { name: 'dur', value: 'dur' }, { name: 'm', value: 'moll' }, { name: 'sus2', value: 'sus2' }, { name: 'sus', value: 'sus' }, { name: '7sus4', value: '7sus4' }, { name: '5+', value: 'aug5' }, { name: 'm5+', value: 'maug5' }, { name: 'm-5', value: 'mm5' }, { name: 'm7-5', value: 'm7m5' }, { name: '6', value: '6' }, { name: 'm6', value: 'm6' }, { name: '7', value: '7' }, { name: 'm7', value: 'm7' }, { name: 'maj7', value: 'maj7' }, { name: 'dim7', value: 'dim7' }, { name: '7♭9', value: '7b9' }, { name: '7#9', value: '7s9' }, { name: '9', value: '9' }, { name: 'add9', value: 'add9' }, { name: 'maj9', value: 'maj9' }, { name: '11', value: '11' }, { name: 'add11', value: 'add11' }, { name: '13', value: '13' }];
	
	exports.default = {
	  data: function data() {
	    return {
	      key: undefined,
	      flavour: undefined,
	      stepThrough: false,
	      keys: keys,
	      flavours: flavours
	    };
	  },
	
	  computed: {
	    canClearSelection: function canClearSelection() {
	      return this.key || this.flavour;
	    }
	  },
	  methods: {
	    create: function create(baseNote, flavour) {
	      var notes = [];
	
	      var additionValues = [];
	
	      switch (flavour) {
	        case 'dur':
	          additionValues = [4, 7];
	          break;
	        case 'moll':
	          additionValues = [3, 7];
	          break;
	        case 'sus2':
	          additionValues = [2, 7];
	          break;
	        case 'sus':
	          additionValues = [5, 7];
	          break;
	        case '7sus4':
	          additionValues = [5, 7, 10];
	          break;
	        case 'aug5':
	          additionValues = [4, 8];
	          break;
	        case 'maug5':
	          additionValues = [3, 8];
	          break;
	        case 'mm5':
	          additionValues = [3, 6];
	          break;
	        case 'm7m5':
	          additionValues = [3, 6, 10];
	          break;
	        case '6':
	          additionValues = [4, 7, 9];
	          break;
	        case 'm6':
	          additionValues = [3, 7, 9];
	          break;
	        case '7':
	          additionValues = [4, 7, 10];
	          break;
	        case 'm7':
	          additionValues = [3, 7, 10];
	          break;
	        case '7b9':
	          additionValues = [4, 7, 10, 13];
	          break;
	        case '7s9':
	          additionValues = [4, 7, 10, 15];
	          break;
	        case 'maj7':
	          additionValues = [4, 7, 11];
	          break;
	        case 'dim7':
	          additionValues = [3, 6, 9];
	          break;
	        case '9':
	          additionValues = [4, 7, 10, 14];
	          break;
	        case 'add9':
	          additionValues = [4, 7, 14];
	          break;
	        case 'maj9':
	          additionValues = [4, 7, 11, 14];
	          break;
	        case '11':
	          additionValues = [4, 5, 7, 10, 14];
	          break;
	        case 'add11':
	          additionValues = [4, 5, 7];
	          break;
	        case '13':
	          additionValues = [4, 5, 7, 9, 10, 14];
	          break;
	        default:
	          break;
	      }
	
	      notes.push(baseNote);
	
	      for (var i = 0; i < additionValues.length; i++) {
	        notes.push(baseNote + additionValues[i]);
	      }
	
	      return notes;
	    },
	    clearChordStyles: function clearChordStyles() {
	      var allChordedKeys = document.querySelectorAll('.key.chorded');
	
	      for (var i = 0; i < allChordedKeys.length; i++) {
	        allChordedKeys[i].classList.remove('chorded');
	      }
	    },
	    clearChordSelect: function clearChordSelect() {
	      this.key = undefined;
	      this.flavour = undefined;
	
	      this.clearChordStyles();
	    },
	    disable: function disable() {
	      this.$el.classList.add('disabled');
	    },
	    enable: function enable() {
	      this.$el.classList.remove('disabled');
	    },
	    playChord: function playChord() {
	      var chordKeySelect = parseInt(this.key, 10);
	      var chordFlavourSelect = this.flavour;
	
	      this.clearChordStyles();
	
	      if (isNaN(chordKeySelect)) {
	        this.clearChordSelect();
	
	        return;
	      }
	
	      this.disable();
	
	      var chord = this.create(chordKeySelect, chordFlavourSelect);
	
	      _piano2.default.playChord(chord, this.stepThrough).then(this.enable);
	    }
	  }
	};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _computerKeyboard = __webpack_require__(39);
	
	var _computerKeyboard2 = _interopRequireDefault(_computerKeyboard);
	
	var _midiKeyboard = __webpack_require__(40);
	
	var _midiKeyboard2 = _interopRequireDefault(_midiKeyboard);
	
	var _piano = __webpack_require__(9);
	
	var _piano2 = _interopRequireDefault(_piano);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultKeys = [{ note: 24, name: 'C' }, { note: 25, name: 'C# / D♭' }, { note: 26, name: 'D' }, { note: 27, name: 'D# / E♭' }, { note: 28, name: 'E' }, { note: 29, name: 'F' }, { note: 30, name: 'F# / G♭' }, { note: 31, name: 'G' }, { note: 32, name: 'G# / A♭' }, { note: 33, name: 'A' }, { note: 34, name: 'A# / B♭' }, { note: 35, name: 'B' }, { note: 36, name: 'C' }, { note: 37, name: 'C# / D♭' }, { note: 38, name: 'D' }, { note: 39, name: 'D# / E♭' }, { note: 40, name: 'E' }, { note: 41, name: 'F' }, { note: 42, name: 'F# / G♭' }, { note: 43, name: 'G' }, { note: 44, name: 'G# / A♭' }, { note: 45, name: 'A' }, { note: 46, name: 'A# / B♭' }, { note: 47, name: 'B' }, { note: 48, name: 'C' }, { note: 49, name: 'C# / D♭' }, { note: 50, name: 'D' }, { note: 51, name: 'D# / E♭' }, { note: 52, name: 'E' }, { note: 53, name: 'F' }, { note: 54, name: 'F# / G♭' }, { note: 55, name: 'G' }, { note: 56, name: 'G# / A♭' }, { note: 57, name: 'A' }, { note: 58, name: 'A# / B♭' }, { note: 59, name: 'B' }, { note: 60, name: 'C' }, { note: 61, name: 'C# / D♭' }, { note: 62, name: 'D' }, { note: 63, name: 'D# / E♭' }, { note: 64, name: 'E' }, { note: 65, name: 'F' }, { note: 66, name: 'F# / G♭' }, { note: 67, name: 'G' }, { note: 68, name: 'G# / A♭' }, { note: 69, name: 'A' }, { note: 70, name: 'A# / B♭' }, { note: 71, name: 'B' }, { note: 72, name: 'C' }, { note: 73, name: 'C# / D♭' }, { note: 74, name: 'D' }, { note: 75, name: 'D# / E♭' }, { note: 76, name: 'E' }, { note: 77, name: 'F' }, { note: 78, name: 'F# / G♭' }, { note: 79, name: 'G' }, { note: 80, name: 'G# / A♭' }, { note: 81, name: 'A' }, { note: 82, name: 'A# / B♭' }, { note: 83, name: 'B' }, { note: 84, name: 'C' }, { note: 85, name: 'C# / D♭' }, { note: 86, name: 'D' }, { note: 87, name: 'D# / E♭' }, { note: 88, name: 'E' }, { note: 89, name: 'F' }, { note: 90, name: 'F# / G♭' }, { note: 91, name: 'G' }, { note: 92, name: 'G# / A♭' }, { note: 93, name: 'A' }, { note: 94, name: 'A# / B♭' }, { note: 95, name: 'B' }, { note: 96, name: 'C' }, { note: 97, name: 'C# / D♭' }, { note: 98, name: 'D' }, { note: 99, name: 'D# / E♭' }, { note: 100, name: 'E' }, { note: 101, name: 'F' }, { note: 102, name: 'F# / G♭' }, { note: 103, name: 'G' }, { note: 104, name: 'G# / A♭' }, { note: 105, name: 'A' }, { note: 106, name: 'A# / B♭' }, { note: 107, name: 'B' }];
	
	var keys = defaultKeys.map(function (key) {
	  var sharp = key.name.indexOf('#') !== -1;
	  var additionalClass = sharp ? ' sharp' : '';
	
	  key.class = 'key' + additionalClass;
	
	  return key;
	});
	
	exports.default = {
	  methods: {
	    mouseUp: function mouseUp(event) {
	      _piano2.default.state.mouseDown = false;
	      this.stopNote(event.target.dataset.note);
	    },
	    mouseDown: function mouseDown(event) {
	      if (_piano2.default.state.mouseDown) {
	        return;
	      }
	
	      _piano2.default.state.mouseDown = true;
	      this.startNote(event.target.dataset.note);
	    },
	    mouseOver: function mouseOver(event) {
	      if (_piano2.default.state.mouseDown) {
	        this.startNote(event.target.dataset.note);
	      }
	    },
	    mouseOut: function mouseOut(event) {
	      if (!_piano2.default.state.mouseDown) {
	        return;
	      }
	
	      if (!event.relatedTarget.classList.contains('key')) {
	        _piano2.default.state.mouseDown = false;
	      }
	
	      this.stopNote(event.target.dataset.note);
	    },
	    startNote: function startNote(midiNumber) {
	      _piano2.default.startNote(midiNumber);
	    },
	    stopNote: function stopNote(midiNumber) {
	      _piano2.default.stopNote(midiNumber);
	    },
	    onNoteStart: function onNoteStart(options) {
	      var midiNumber = options.midiNumber,
	          chorded = options.chorded;
	
	      var key = this.$el.querySelector('[data-note="' + midiNumber + '"]');
	
	      key.classList.add('playing');
	
	      if (chorded) {
	        key.classList.add('chorded');
	      }
	    },
	    onNoteStop: function onNoteStop(options) {
	      var midiNumber = options.midiNumber;
	
	      var key = this.$el.querySelector('[data-note="' + midiNumber + '"]');
	
	      key.classList.remove('playing');
	    },
	    disable: function disable() {
	      this.$el.querySelector('.keys').classList.add('loading');
	    },
	    enable: function enable() {
	      document.querySelector('.keys').classList.remove('loading');
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var keyHolder = this.$el;
	
	    if (keyHolder.scrollWidth > keyHolder.clientWidth) {
	      keyHolder.scrollLeft = (keyHolder.scrollWidth - keyHolder.clientWidth) / 2;
	    }
	
	    _computerKeyboard2.default.init();
	    _midiKeyboard2.default.init();
	
	    document.addEventListener('noteStart', function (event) {
	      _this.onNoteStart(event.detail);
	    }, { passive: true });
	
	    document.addEventListener('noteStop', function (event) {
	      _this.onNoteStop(event.detail);
	    }, { passive: true });
	  },
	  data: function data() {
	    return { keys: keys };
	  }
	};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sampler = __webpack_require__(16);
	
	var _sampler2 = _interopRequireDefault(_sampler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var startRecordingString = 'Start recording';
	var stopRecordingString = 'Stop recording';
	
	var mediaRecorder = void 0;
	var chunks = void 0;
	
	exports.default = {
	  data: function data() {
	    return {
	      buttonText: startRecordingString,
	      isRecording: false
	    };
	  },
	
	
	  computed: {
	    buttonText: function buttonText() {
	      return this.isRecording ? stopRecordingString : startRecordingString;
	    },
	    className: function className() {
	      var stateClass = this.isRecording ? ' recording' : '';
	
	      return 'recorder' + stateClass;
	    }
	  },
	
	  methods: {
	    toggleRecordingStartStop: function toggleRecordingStartStop() {
	      if (this.isRecording) {
	        this.stopRecording();
	      } else {
	        this.startRecording();
	      }
	    },
	    startRecording: function startRecording() {
	      chunks = [];
	      mediaRecorder.start();
	      this.isRecording = true;
	    },
	    stopRecording: function stopRecording() {
	      mediaRecorder.stop();
	      this.isRecording = false;
	    },
	    loadRecording: function loadRecording() {
	      var fileReader = new FileReader();
	
	      fileReader.onload = function (event) {
	        _sampler2.default.loadArrayBuffer(event.target.result);
	      };
	
	      fileReader.readAsArrayBuffer(new Blob(chunks));
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    navigator.getUserMedia({
	      audio: true
	    }, function (stream) {
	      mediaRecorder = new MediaRecorder(stream);
	
	      mediaRecorder.ondataavailable = function (e) {
	        chunks.push(e.data);
	      };
	
	      mediaRecorder.onstop = _this.loadRecording;
	    }, function (err) {
	      console.error('The following gUM error occured: ' + err);
	    });
	  }
	};

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  mounted: function mounted() {
	    (function () {
	      var po = document.createElement('script');po.type = 'text/javascript';po.async = true;
	      po.src = '//apis.google.com/js/plusone.js';
	      var s = document.getElementsByTagName('script')[0];s.parentNode.insertBefore(po, s);
	    })();
	    !function (d, s, id) {
	      var js,
	          fjs = d.getElementsByTagName(s)[0];
	      if (!d.getElementById(id)) {
	        js = d.createElement(s);js.id = id;js.src = "//platform.twitter.com/widgets.js";fjs.parentNode.insertBefore(js, fjs);
	      }
	    }(document, "script", "twitter-wjs");
	    (function (d, s, id) {
	      var js,
	          fjs = d.getElementsByTagName(s)[0];
	      if (d.getElementById(id)) return;
	      js = d.createElement(s);js.id = id;
	      js.src = "//connect.facebook.net/sv_SE/all.js#xfbml=1&appId=273405689484056";
	      fjs.parentNode.insertBefore(js, fjs);
	    })(document, 'script', 'facebook-jssdk');
	  }
	};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sampler = __webpack_require__(16);
	
	var _sampler2 = _interopRequireDefault(_sampler);
	
	var _recorder = __webpack_require__(104);
	
	var _recorder2 = _interopRequireDefault(_recorder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
	
	var families = [{
	  id: 0,
	  name: 'Keyboard'
	}, {
	  id: 1,
	  name: 'Strings'
	}, {
	  id: 2,
	  name: 'Woodwind'
	}, {
	  id: 3,
	  name: 'Brass'
	}, {
	  id: 4,
	  name: 'Special',
	  disabled: true
	}];
	
	var sounds = [{
	  name: 'Grand Piano',
	  value: 'piano.mp3',
	  family: 0
	}, {
	  name: 'Guitar',
	  value: 'guitar.mp3',
	  family: 1
	}, {
	  name: 'Bass',
	  value: 'bass.mp3',
	  family: 1
	}, {
	  name: 'Banjo',
	  value: 'banjo.mp3',
	  family: 1
	}, {
	  name: 'Viola',
	  value: 'viola.mp3',
	  family: 1
	}, {
	  name: 'Violin',
	  value: 'violin.mp3',
	  family: 1
	}, {
	  name: 'Cello',
	  value: 'cello.mp3',
	  family: 1
	}, {
	  name: 'Clarinet',
	  value: 'clarinet.mp3',
	  family: 2
	}, {
	  name: 'Bassoon',
	  value: 'bassoon.mp3',
	  family: 2
	}, {
	  name: 'Contrabassoon',
	  value: 'contrabassoon.mp3',
	  family: 2
	}, {
	  name: 'Saxophone',
	  value: 'saxophone.mp3',
	  family: 3
	}, {
	  name: 'French horn',
	  value: 'french-horn.mp3',
	  family: 3
	}, {
	  name: 'Trombone',
	  value: 'trombone.mp3',
	  family: 3
	}, {
	  name: 'Trumpet',
	  value: 'trumpet.mp3',
	  family: 3
	}, {
	  name: 'My own (open file)',
	  value: 'open-file',
	  family: 4,
	  disabled: true
	}, {
	  name: 'Record',
	  value: 'record',
	  family: 4,
	  disabled: true
	}];
	
	var enabledFamilies = families.filter(function (family) {
	  return !family.disabled;
	});
	var enabledSounds = sounds.filter(function (sound) {
	  return !sound.disabled;
	});
	
	exports.default = {
	  components: { Recorder: _recorder2.default },
	  data: function data() {
	    return {
	      sound: 'piano.mp3',
	      families: enabledFamilies,
	      sounds: enabledSounds
	    };
	  },
	
	
	  computed: {
	    canShowFileInput: function canShowFileInput() {
	      return this.sound === 'open-file';
	    },
	    canShowRecorder: function canShowRecorder() {
	      return this.sound === 'record' && navigator.getUserMedia;
	    }
	  },
	
	  methods: {
	    loadSound: function loadSound() {
	      var disallowedSounds = ['open-file', 'record'];
	
	      if (disallowedSounds.indexOf(this.sound) !== -1) {
	        return;
	      }
	
	      var soundPath = _sampler2.default.makePathFromSoundName(this.sound);
	
	      _sampler2.default.loadSound(soundPath);
	    },
	    readFile: function readFile(file) {
	      var fileReader = new FileReader();
	
	      fileReader.onload = function (event) {
	        var arrayBuffer = event.target.result;
	
	        _sampler2.default.loadArrayBuffer(arrayBuffer);
	      };
	
	      fileReader.readAsArrayBuffer(file);
	    },
	    filteredSounds: function filteredSounds(familyId) {
	      return this.sounds.filter(function (sound) {
	        return sound.family === familyId;
	      });
	    },
	    fileOpen: function fileOpen(event) {
	      var file = event.target.files[0];
	
	      if (file.type.indexOf('audio') !== -1) {
	        this.readFile(file);
	      } else {
	        alert('Not an audio file.');
	      }
	    }
	  }
	};

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(92)
	
	/* script */
	__vue_exports__ = __webpack_require__(41)
	
	/* template */
	var __vue_template__ = __webpack_require__(115)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(90)
	
	/* script */
	__vue_exports__ = __webpack_require__(42)
	
	/* template */
	var __vue_template__ = __webpack_require__(113)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-654af1ee"
	
	module.exports = __vue_exports__


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(88)
	
	/* script */
	__vue_exports__ = __webpack_require__(44)
	
	/* template */
	var __vue_template__ = __webpack_require__(111)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1f93ab0a"
	
	module.exports = __vue_exports__


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(89)
	
	/* script */
	__vue_exports__ = __webpack_require__(45)
	
	/* template */
	var __vue_template__ = __webpack_require__(112)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3bbab540"
	
	module.exports = __vue_exports__


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(87)
	
	/* script */
	__vue_exports__ = __webpack_require__(46)
	
	/* template */
	var __vue_template__ = __webpack_require__(110)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-10f0ebe0"
	
	module.exports = __vue_exports__


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(94)
	
	/* script */
	__vue_exports__ = __webpack_require__(47)
	
	/* template */
	var __vue_template__ = __webpack_require__(117)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-cef50480"
	
	module.exports = __vue_exports__


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(95)
	
	/* script */
	__vue_exports__ = __webpack_require__(43)
	
	/* template */
	var __vue_template__ = __webpack_require__(118)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f40f5f10"
	
	module.exports = __vue_exports__


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(91)
	
	/* script */
	__vue_exports__ = __webpack_require__(48)
	
	/* template */
	var __vue_template__ = __webpack_require__(114)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-76144b04"
	
	module.exports = __vue_exports__


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(86)
	
	/* template */
	var __vue_template__ = __webpack_require__(109)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-06ae1820"
	
	module.exports = __vue_exports__


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(93)
	
	/* script */
	__vue_exports__ = __webpack_require__(49)
	
	/* template */
	var __vue_template__ = __webpack_require__(116)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a5ea14c0"
	
	module.exports = __vue_exports__


/***/ }),
/* 109 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "social-links"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://www.facebook.com/plypp",
	      "title": "Plypp on Facebook"
	    }
	  }, [_vm._v("Plypp on Facebook")]), _c('br'), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://twitter.com/plypp_piano",
	      "title": "Plypp on Twitter"
	    }
	  }, [_vm._v("@plypp_piano")]), _c('br'), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://plus.google.com/+PlyppNet",
	      "title": "Plypp on Google+",
	      "rel": "publisher"
	    }
	  }, [_vm._v("Plypp on G+")]), _c('br'), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://plypp.userecho.com/",
	      "title": "Report bugs"
	    }
	  }, [_vm._v("Report bugs / Add suggestions")]), _c('br')])
	}]}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "key-holder"
	  }, [_c('div', {
	    staticClass: "keys"
	  }, _vm._l((_vm.keys), function(key) {
	    return _c('button', {
	      class: key.class,
	      attrs: {
	        "data-note": key.note
	      },
	      on: {
	        "pointerup": function($event) {
	          return _vm.mouseUp($event)
	        },
	        "pointerdown": function($event) {
	          return _vm.mouseDown($event)
	        },
	        "pointerover": function($event) {
	          return _vm.mouseOver($event)
	        },
	        "pointerout": function($event) {
	          return _vm.mouseOut($event)
	        }
	      }
	    })
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ads-container"
	  }, [_c('ins', {
	    staticClass: "adsbygoogle",
	    staticStyle: {
	      "display": "inline-block",
	      "width": "728px",
	      "height": "90px"
	    },
	    attrs: {
	      "data-ad-client": "ca-pub-9675050026743432",
	      "data-ad-slot": "8575911567"
	    }
	  })])
	}]}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('fieldset', {
	    staticClass: "chord-selector"
	  }, [_c('legend', [_vm._v("Chord Selector")]), _vm._v(" "), _c('label', [_c('span', [_vm._v("Base")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.key),
	      expression: "key"
	    }],
	    attrs: {
	      "id": "chord-selector-key"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.key = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.playChord]
	    }
	  }, _vm._l((_vm.keys), function(key) {
	    return _c('option', {
	      domProps: {
	        "value": key.value
	      }
	    }, [_vm._v(_vm._s(key.name))])
	  }), 0)]), _vm._v(" "), _c('label', [_c('span', [_vm._v("Flavour")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.flavour),
	      expression: "flavour"
	    }],
	    attrs: {
	      "id": "chord-selector-flavour"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.flavour = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.playChord]
	    }
	  }, _vm._l((_vm.flavours), function(flavour) {
	    return _c('option', {
	      domProps: {
	        "value": flavour.value
	      }
	    }, [_vm._v(_vm._s(flavour.name))])
	  }), 0)]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.stepThrough),
	      expression: "stepThrough"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.stepThrough) ? _vm._i(_vm.stepThrough, null) > -1 : (_vm.stepThrough)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.stepThrough,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.stepThrough = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.stepThrough = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.stepThrough = $$c
	        }
	      }, _vm.playChord]
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Step through chord")])]), _vm._v(" "), (_vm.canClearSelection) ? _c('button', {
	    on: {
	      "click": _vm.clearChordSelect
	    }
	  }, [_vm._v("Clear")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "app"
	  }, [_c('main', [_c('div', {
	    staticClass: "left-panel"
	  }, [_c('sound-selector')], 1), _vm._v(" "), _c('div', {
	    staticClass: "right-panel"
	  }, [_c('chord-selector')], 1)]), _vm._v(" "), _c('footer', [_c('div', {
	    staticClass: "key-holder"
	  }, [_c('keyboard')], 1), _vm._v(" "), _c('ads-container'), _vm._v(" "), _c('social-footer')], 1)])
	},staticRenderFns: []}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "social-interactions"
	  }, [_c('div', {
	    attrs: {
	      "id": "fb-root"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fb-like",
	    attrs: {
	      "data-send": "true",
	      "data-href": "https://www.facebook.com/plypp",
	      "data-layout": "button_count",
	      "data-show-faces": "false"
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "twitter-share-button",
	    attrs: {
	      "href": "https://twitter.com/plypp_piano",
	      "data-related": "jasoncosta",
	      "data-lang": "en",
	      "data-size": "large",
	      "data-count": "none"
	    }
	  }, [_vm._v("Tweet")]), _vm._v(" "), _c('a', {
	    staticClass: "twitter-follow-button",
	    attrs: {
	      "href": "https://twitter.com/plypp_piano",
	      "data-show-count": "false",
	      "data-lang": "en"
	    }
	  }, [_vm._v("Follow @plypp_piano")]), _vm._v(" "), _c('div', {
	    staticClass: "g-plusone"
	  })])
	}]}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('plypp')
	},staticRenderFns: []}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('fieldset', {
	    staticClass: "sound-selector",
	    on: {
	      "change": function($event) {
	        return _vm.loadSound()
	      }
	    }
	  }, [_c('legend', [_vm._v("Sound Selector")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sound),
	      expression: "sound"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.sound = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.families), function(f) {
	    return _c('optgroup', {
	      attrs: {
	        "label": f.name
	      }
	    }, _vm._l((_vm.filteredSounds(f.id)), function(sound) {
	      return _c('option', {
	        domProps: {
	          "value": sound.value
	        }
	      }, [_vm._v(_vm._s(sound.name))])
	    }), 0)
	  }), 0), _vm._v(" "), (_vm.canShowFileInput) ? _c('input', {
	    attrs: {
	      "type": "file"
	    },
	    on: {
	      "change": _vm.fileOpen
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.canShowRecorder) ? _c('recorder') : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.className
	  }, [_c('button', {
	    on: {
	      "click": _vm.toggleRecordingStartStop
	    }
	  }, [_vm._v(_vm._s(_vm.buttonText))])])
	},staticRenderFns: []}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "social-interactions"
	  }, [_c('social-interactions'), _vm._v(" "), _c('social-links')], 1)
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.fa10513cde56fc08942a.js